import {capacitorPlugin} from "@/assets/plugins/mps-mobile-capacitor-app/capacitor-plugin";

const install = (Vue, options) => {
    Vue.prototype.$capacitorPlugin = capacitorPlugin;
};


export default {install}
